import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterControls = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  totalCount,
  filteredCount 
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'pending', label: 'Pending' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' }
  ];

  const handleInputChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        <div className="flex flex-col sm:flex-row gap-4 flex-1">
          <div className="flex-1 max-w-xs">
            <Input
              type="search"
              placeholder="Search clients or projects..."
              value={filters?.search}
              onChange={(e) => handleInputChange('search', e?.target?.value)}
            />
          </div>
          
          <div className="w-full sm:w-48">
            <Select
              options={statusOptions}
              value={filters?.status}
              onChange={(value) => handleInputChange('status', value)}
              placeholder="Filter by status"
            />
          </div>
          
          <div className="w-full sm:w-48">
            <Select
              options={dateRangeOptions}
              value={filters?.dateRange}
              onChange={(value) => handleInputChange('dateRange', value)}
              placeholder="Filter by date"
            />
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <Button
            variant="ghost"
            size="sm"
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear Filters
          </Button>
        </div>
      </div>
      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <span>
          Showing {filteredCount} of {totalCount} feedback responses
        </span>
        {filteredCount !== totalCount && (
          <span className="text-accent">Filters applied</span>
        )}
      </div>
    </div>
  );
};

export default FilterControls;